module.exports = __webpack_public_path__ + "static/img/erweim.06dbc0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweim.png
// module id = Gi4m
// module chunks = 4